import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

const TEXT_STYLE = { fontSize: 12 };
const LINK_TEXT_STYLE = { ...TEXT_STYLE, color: "#FF5200", fontWeight: 600 };

// Shared "Campaign" DataGrid cell for the Reports page's tabs — same route +
// "open in new tab" convention as PaymentTableRow.js's own campaign name
// link, so a campaign can be opened straight from wherever its name shows up
// without losing the report's filters/table state underneath it. Falls back
// to plain text when there's no id to link to.
export function CampaignLink({ id, name }) {
    if (!id) return <Typography sx={TEXT_STYLE}>{name || "-"}</Typography>;
    return (
        <Link to={`/payments/campaigns/details/${id}`} target="blank">
            <Typography sx={LINK_TEXT_STYLE}>{name}</Typography>
        </Link>
    );
}
